import { render } from "./BirthplaceMapWidgetAccount.vue?vue&type=template&id=3fe39726&scoped=true"
import script from "./BirthplaceMapWidgetAccount.vue?vue&type=script&lang=js"
export * from "./BirthplaceMapWidgetAccount.vue?vue&type=script&lang=js"

import "./BirthplaceMapWidgetAccount.vue?vue&type=style&index=0&id=3fe39726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe39726"]])

export default __exports__